import { TableCell } from '@mui/material'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { MonthlySummary, YearlySummary } from '../../store/redux/reducers/yearlySummarySlice'
import { CollapsableRow, Row } from '../../store/types/utils/DataTableUtils'
import CollapsibleTable from './CollapsibleTable/CollapsibleTable'
import TransitionTableCell from './CollapsibleTable/TransitionTableCell'

interface VacationsTableProps {
  yearlySummary: YearlySummary | undefined
  daysMode: boolean
}

export const VacationsTable = ({ yearlySummary, daysMode }: VacationsTableProps) => {
  const { t } = useTranslation()
  let data: MonthlySummary[] = []
  if (yearlySummary) {
    Object.assign(data, Array.from(Object.values(yearlySummary))[0])
    data.shift()
  }

  const columns = [
    { id: 'month', label: t('components.vacationTable.header.month') },
    { id: 'vacationTime', label: t('components.vacationTable.header.vacationTime') },
    { id: 'description', label: '' },
  ]

  const collapsableRows: CollapsableRow[] = data.map((row, index) => ({
    ...row,
    index: index,
    hasCollapsedData: row.vacationDays && row.vacationDays.length > 0,
    collapsedData:
      row.vacationDays && row.vacationDays.length > 0
        ? row.vacationDays.map((value, index2) => ({ id: index2.toString(), ...value }))
        : [],
  }))

  const renderRow = (monthlySummary: CollapsableRow) => {
    const vacationSum = monthlySummary.vacationPaid + monthlySummary.vacationUnpaid

    return (
      <>
        <TableCell sx={{ pl: 0, py: 1 }}>{dayjs().month(monthlySummary.index).format('MMMM')}</TableCell>
        <TableCell align={'center'} sx={{ pr: '0px !important', py: 1 }}>
          {daysMode ? Math.round((vacationSum * 10) / 8) / 10 + 'd' : vacationSum + 'h'}
        </TableCell>
        <TableCell />
      </>
    )
  }

  const renderCollapsedRow = (row: Row, open: boolean) => {
    return (
      <>
        <TransitionTableCell sx={{ padding: '0px', minWidth: { xs: '35px', sm: '48px' } }} open={open} />
        <TransitionTableCell sx={{ pl: 0 }} open={open}>
          {dayjs(row.date).format('DD.MM dddd')}
        </TransitionTableCell>
        <TransitionTableCell align="center" sx={{ pr: '0px !important' }} open={open}>
          {daysMode ? Math.round((row.hours * 10) / 8) / 10 + 'd' : row.hours + 'h'}
        </TransitionTableCell>
        <TransitionTableCell
          sx={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            minWidth: { xs: '100px', sm: '' },
          }}
          open={open}
        >
          {row.isPaid ? '$' : ''}
        </TransitionTableCell>
      </>
    )
  }

  return (
    <>
      <CollapsibleTable
        columns={columns}
        collapsableRows={collapsableRows}
        renderRow={renderRow}
        renderCollapsedRow={renderCollapsedRow}
        fullHeight={true}
      />
    </>
  )
}
